import { render, staticRenderFns } from "./PackImportQuestionCard.vue?vue&type=template&id=01d0fd1e&scoped=true&"
import script from "./PackImportQuestionCard.vue?vue&type=script&lang=js&"
export * from "./PackImportQuestionCard.vue?vue&type=script&lang=js&"
import style0 from "./PackImportQuestionCard.vue?vue&type=style&index=0&id=01d0fd1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d0fd1e",
  null
  
)

export default component.exports